import { StyledContainer } from "./StyledComponents";
import { ServerTimeHelper } from "@kaltura/mediaspace-shared-utils";
import Title from "./title/Title";
import Schedule from "./schedule/Schedule";
import Actions from "./actions/Actions";
import { LobbyProps } from "../Lobby";

export type DetailsProps = Omit<LobbyProps, "videoUrl" | "thumbnailUrl">;

/**
 * Lobby Details - title, scheduling, actions.
 */
const Details = (props: DetailsProps) => {
    const { schedulingData, statusLabel, alwaysShowStatusLabel, title, actions } = props;

    const staticClassBase = "kms-ds-media-page-lobby-details";

    const isScheduled = !!schedulingData;
    const showCounter = isScheduled && ServerTimeHelper.getUpdatedTime() < schedulingData.from;

    return (
        <StyledContainer className={staticClassBase}>
            {(title || alwaysShowStatusLabel) && (
                <Title
                    title={title}
                    showCounter={showCounter}
                    startTime={schedulingData?.from}
                    statusLabel={statusLabel}
                />
            )}

            {isScheduled && <Schedule schedulingData={schedulingData} />}

            {actions && actions.length > 0 && <Actions actions={actions} />}
        </StyledContainer>
    );
};

export default Details;
